import Typescript from './Typescript'
export default Typescript
